import React, {useEffect, useState} from 'react';
import {getTimeAndScore} from '../../helpers/gameUtils';
import secondsToHMSformat from "../helpers/secondsToHMSformat";
import Chip from "@mui/material/Chip";
import {TimerOutlined} from "@mui/icons-material";
import {useSelector} from "react-redux";

const Time = (props) => {
  const [now, setNow] = useState(new Date().getTime() / 1000);

  const questionHistory = useSelector((state) => state.team?.teamDetails?.questions) || {};
  const scoreAndTime = getTimeAndScore(questionHistory, props.currentCourse);
  const {completedQuestionTime, inProgressQuestionTimeStart} = scoreAndTime;


  const time = !!inProgressQuestionTimeStart ? completedQuestionTime + now - inProgressQuestionTimeStart : completedQuestionTime;

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Math.round(new Date().getTime() / 1000));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (<>
    <Chip
      icon={<TimerOutlined/>}
      label={secondsToHMSformat(time)}
      color={inProgressQuestionTimeStart ? 'primary' : 'default'}
      sx={{ minWidth: '87px', m: '0 8px' }}
    />
  </>)
};

export default Time;